import styled from 'styled-components';

import colors from '../../../../styles/colors';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 10px 0;
`;

const Pill = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 80%;
  padding: 8px 40px;
  border-radius: 10px;
  background-color: ${colors.base.alpha};
  border: 1px solid ${colors.shades.gamma1};
  word-wrap: break-word;
  word-break: break-word;
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;

const TitleText = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
`;

const DescriptionText = styled.span`
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${colors.shades.beta2};
`;

const TimeText = styled.div`
  font-size: 0.62rem;
  color: ${colors.shades.gamma2};
  margin-top: 3px;
`;

export {
  Container,
  Pill,
  Row,
  TitleText,
  DescriptionText,
  TimeText,
};
